import React from "react";
import "./transparent-loader.css";

const TransparentLoader = ({ show = false }) => {
	if (!show) return null;

	return (
		<div className="transparent-loader-overlay">
			<div className="transparent-loader-container">
				<div id="preloader">
					<div className="sk-three-bounce">
						<div className="sk-child sk-bounce1"></div>
						<div className="sk-child sk-bounce2"></div>
						<div className="sk-child sk-bounce3"></div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default TransparentLoader;
